let suffix_role = "";
if (process.env.REACT_APP_PROFILE !== "prod") {
  suffix_role = "_demo";
}

const ROLES = {
  // Super Admin Role
  SUPER_ADMIN: "c2c_super_admin" + suffix_role,

  // Client Roles
  CLIENT_VIEWER: "c2c_client_viewer" + suffix_role,
  CLIENT_ADMIN: "c2c_client_admin" + suffix_role,

  // Client Roles
  BUDGET_VIEWER: "c2c_budget_viewer" + suffix_role,
  BUDGET_ADMIN: "c2c_budget_admin" + suffix_role,
  // Estimation Roles
  ESTIMATION_VIEWER: "c2c_est_viewer" + suffix_role,
  ESTIMATION_ADMIN: "c2c_est_admin" + suffix_role,

  // Pricing Roles
  PRICING_VIEWER: "c2c_pricing_viewer" + suffix_role,
  PRICING_ADMIN: "c2c_pricing_admin" + suffix_role,

  // SOW Roles
  SOW_VIEWER: "c2c_sow_viewer" + suffix_role,
  SOW_ADMIN: "c2c_sow_admin" + suffix_role,

  // Milestone Roles
  MILESTONE_VIEWER: "c2c_milestone_viewer" + suffix_role,
  MILESTONE_ADMIN: "c2c_milestone_admin" + suffix_role,

  // PO Roles
  PO_VIEWER: "c2c_po_viewer" + suffix_role,
  PO_ADMIN: "c2c_po_admin" + suffix_role,

  // Allocation Roles
  ALLOCATION_VIEWER: "c2c_allocation_viewer" + suffix_role,
  ALLOCATION_ADMIN: "c2c_allocation_admin" + suffix_role,

  // Resource Roles
  RESOURCE_VIEWER: "c2c_resource_viewer" + suffix_role,

  // Timesheet Roles
  TIMESHEET_MANAGER: "c2c_timesheet_manager" + suffix_role,
  TIMESHEET_ADMIN: "c2c_timesheet_admin" + suffix_role,
  TIMESHEET_EXPORT_USER: "c2c_timesheet_export_user" + suffix_role,
  TIMESHEET_EMPLOYEE: "c2c_timesheet_employee" + suffix_role,
  PROXY_TS_USER: "c2c_proxy_timesheet_user" + suffix_role,

  // Dashboard Role
  DASHBOARD_VIEWER: "c2c_dashboard_viewer" + suffix_role,

  // Invoice Roles
  INVOICE_VIEWER: "c2c_invoice_viewer" + suffix_role,
  INVOICE_ADMIN: "c2c_invoice_admin" + suffix_role,

  // HR and Management Roles
  HR_MANAGER: "c2c_hr_manager" + suffix_role,
  PMO_USER: "c2c_pmo_user" + suffix_role,

  // General Viewer Role
  VIEWER: "c2c_viewer" + suffix_role,

  // Guest Role
  GUEST_EMPLOYEE: "c2c_guest_employee" + suffix_role,

  // Employee Management
 EMPLOYEE_MANAGEMENT_VIEWER: "c2c_emoloyee_management_viewer" + suffix_role,
  EMPLOYEE_MANAGEMENT_ADMIN: "c2c_emoloyee_management_admin" + suffix_role,

  // Asset Role
  ASSET_ADMIN: "c2c_asset_admin" + suffix_role,
  ASSET_VIEWER: "c2c_asset_viewer" + suffix_role
};

export default ROLES;
